import { Component, OnInit } from '@angular/core';
import { each} from 'lodash';
import { ANALYTICS, COMMON_CONSTANTS, ENTITLEMENT_ACTIVITYNAMES, MANAGE_LINE_CONST } from 'src/app/common/core/common.constants';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { PDLService } from 'src/app/services/pdl-service.service';
import { UtilsService } from 'src/app/services/utils.service';
import { isNullOrUndefined } from 'src/app/services/utils';

@Component({
  selector: 'app-add-accountname',
  templateUrl: './add-accountname.component.html',
  styleUrls: ['./add-accountname.component.scss']
})
export class AddAccountnameComponent implements OnInit {
  authoringContentData: any;
  header: any;
  banDetails:any;
  newBanName: any;
  confirmBtnFlag: boolean = false;
  banName: any;
  banAPiFailureFlag: boolean;
  isSubmitReadOnly: boolean;
  banDetail: any;

  constructor(public manageLineService: ManageLineService,private utilsSvc: UtilsService,
    private _cacheSvc: HttpCacheService, private _loaderSvc: LoaderService, private pdlService: PDLService) { }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.banName = !isNullOrUndefined(this.banDetail.banFriendlyName) ? this.banDetail.banFriendlyName : '';
    this.isSubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.ADD_ACCOUNT_FRIENDLY_NAME);
    this.confirmBtnFlag = false;
    this.banAPiFailureFlag = false;
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: this.getModalName(),
    });
  }

  getModalName() {
    const translate = {};
    translate[this.authoringContentData.accountListingPage.addAccountName] = ANALYTICS.ADD_ACC_NAME;
    translate[this.authoringContentData.accountListingPage.updateAccountName] = ANALYTICS.UPDATE_ACC_NAME;
    return translate[this.header] || '';
  }


  onKeyup(inputValue){
    this.newBanName = inputValue;
    if(this.newBanName && this.newBanName !==this.banName){
      this.confirmBtnFlag = true;
    } else {
      this.confirmBtnFlag = false;
    }
  }

  updateBanName(){
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CONFIRM,
      assetType: ANALYTICS.BUTTON,
      modalName: this.getModalName()
    });
    this._loaderSvc.start();
    const billingAccount = !isNullOrUndefined(this.banDetail.billingAccount) ? this.banDetail.billingAccount : '';
    this.manageLineService.updateFriendlyName(billingAccount, this.newBanName).subscribe((response) => {
      if(response.orgIdList[0].status==MANAGE_LINE_CONST.SUCCESS){
        this.banDetail.banFriendlyName = this.newBanName;
        this._loaderSvc.stop();
        this.manageLineService.close();
        this.banAPiFailureFlag = false;
        this.banDetails = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_LIST_RESPONSE));
        each(this.banDetails, (item) => {
          if (item.billingAccount === billingAccount ) {
            item['banFriendlyName']= this.newBanName;
          }
        });
        this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.BAN_LIST_RESPONSE,JSON.stringify(this.banDetails));
        this.manageLineService.banFriendlyName.next(this.newBanName);
      }
    }, (err) => {
      this.banAPiFailureFlag = true;
      this._loaderSvc.stop();
    });
  }

  onCloseClick() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CLOSE,
      assetType: ANALYTICS.BUTTON,
      modalName: this.getModalName()
    });
    this.manageLineService.close();
  }

  onCancelClick() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CANCEL,
      assetType: ANALYTICS.BUTTON,
      modalName: this.getModalName()
    });
    this.manageLineService.close();
  }

}
